export default __webpack_public_path__ + "assets/ProfileNoCircle.c3e2.svg";